/* angular:styles/component:css;76a3544b5d3beba0c09fb1763e9b017c91aa1833b1381014420bf80f0eaebe8f;/src/src/app/shared/components/formly/formly-field-navigation/formly-field-navigation.ts */
::ng-deep formly-form {
  height: 100% !important;
}
.custom-title {
  color: var(--ion-text-color);
  font-size: 1.25rem;
  font-weight: 500;
}
/*# sourceMappingURL=formly-field-navigation.css.map */
